export const urls = {
    counters: id => `/api/users/${ id }/reviews/seller/counters`
};

export const initialState = {
    data: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_REVIEWS_COUNTERS':
            return {
                data: state.data || {},
                isFetching: true,
                isError: false
            };
        case 'RECEIVE_REVIEWS_COUNTERS':
            return {
                data: {
                    ...state.data,
                    ... { [action.url]: action.data.data }
                },
                isFetching: false,
                isError: false
            };
        case 'ERROR_REVIEWS_COUNTERS':
            return {
                data: state.data || {},
                isFetching: false,
                isError: true
            };
        default:
            return state;
    }
};
